const regex = /\/teams\/([0-9a-fA-F-]{36})\/members\/([0-9a-fA-F-]{36})/

export function extractUuidsFromInvitationAcceptPath(path: string): {
  teamID: string
  teamMemberID: string
} {
  const match = path.match(regex)

  if (!match) {
    throw new Error("Invalid invitation accept path format")
  }
  return {
    teamID: match[1],
    teamMemberID: match[2]
  }
}
